import React from "react"

export default class GagImage extends React.Component {
    render() {
        return <img
                    src={process.env.REACT_APP_API_URL + '/api/gagmedia_file_content/' + this.props.gag.id}
                    alt={this.props.gag.name}
                />
    }
}
